import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosPlantillaGenerarFormularioComponent {
  etiquetasRequeridas = []

  constructor () {
  }

  $onInit () {
    this.etiquetasRequeridas = this.etiquetasRequeridas
      .reduce((etiquetasRequeridas, etiqueta) => ({...etiquetasRequeridas, [etiqueta.nombre]: etiqueta}), {})
  }
}

module.component('fanProyectoDocumentosPlantillaGenerarFormulario', {
  controller: FanProyectoDocumentosPlantillaGenerarFormularioComponent,
  template,
  bindings: {
    config: '<',
    etiquetasRequeridas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/generar/formulario/component.js